<template>
	<div class="clue-drawer">
		<drawerHeader v-bind="headerInfo" :logo="logo" v-on="$listeners" :dataType="dataType" :mobile="headerInfo.psid"></drawerHeader>
		<sky-tabs v-model="tabValue" :tabList="tabList" class="custclass-tab" :customClass="false"></sky-tabs>
		<div class="component">
			<el-scrollbar style="height: 100%">
				<component class="context" :is="tabValue" :isCollapse="false" :tableId="tableId" :id="summaryId"
					:type="type" :summaryId="summaryId" :garbageFlag="headerInfo.garbageFlag"
					:followupName="headerInfo.followupName" :sourceType="headerInfo.sourceType"></component>
			</el-scrollbar>
		</div>
	</div>
</template>
<script>
import skyTabs from '@/components/iglobalwin/formComponents/tabs/sky-tabs.vue';
import drawerHeader from '@/components/chat/drawer-header.vue';
import drawerInfo from '@/components/chat/drawer-info.vue';
import clueContactInfo from '@/components/crm/clue/clue-contactInfo.vue'; //联系人列表

// 我的线索、全部线索
//信息不可编辑 联系人可编辑 ,
// 垃圾线索、都不可编辑
// 操作按钮---这不是垃圾，线索详情
export default {
	props: {
		tableId: {
			type: String, //询盘id
		},
		summaryId: {
			type: String,
		},
		headerInfo: {
			type: Object,
		},
		logo: null,
		dataType: null
	},
	data() {
		return {
			type: 1, //类型：客户为1
			tabValue: 'drawerInfo',
			tabList: [
				{
					label: '信息',
					name: 'drawerInfo',
				},
				{
					label: '联系人',
					name: 'clueContactInfo',
				},
			],
			
		};
	},
	watch: {
		tableId: {
			handler(val) {
				if (val && val != '0') {
					this.tabValue = 'drawerInfo';
				}
			},
			immediate: true,
			deep: true,
		},
		headerInfo:{
			handler(val) {
				if(Object.keys(val).length)
				{
				  this.getData={
					customerId: val.id,
					customerName: val.nickname,
					};
				}
				
			},
			deep: true,
			immediate: true,
		}
	},
	methods: {
		changeName() {
			this.tabValue = 'clueContactInfo';
			this.$nextTick(() => {
				this.tabValue = 'drawerInfo';
			});
			this.$emit('transfer');
		},
		changeGarbageFlag(val) {
			this.garbageFlag = val;
		},
	},
	components: {
		drawerHeader,
		drawerInfo,
		skyTabs,
		clueContactInfo,
	},
};
</script>
<style lang="scss" scoped>
.sky-tabs {
	padding: 0px !important;
}

.custclass-tab {
	::v-deep .el-tabs__header {
		margin: 0px !important;
	}

	::v-deep.el-tabs__item {
		padding-left: 20px !important;
	}
}

.clue-drawer {
	width: 380px;
	height: 100%;
	display: flex;
	flex-direction: column;

	::v-deep .el-tabs {
		.el-tabs__header {
			margin: 0;
		}

		.el-tabs__item {
			padding: 0 10px;
		}

		.el-tabs__active-bar {
			height: 3px;
		}

		.el-tabs__nav-wrap {
			background-color: #fafafa;
			padding: 0 5px;
		}

		.el-tabs__nav-wrap::after {
			height: 1px;
		}
	}
}

.component {
	height: calc(100vh - 345px);

	.context {
		min-height: calc(100vh - 570px);
	}

	/* height: calc(100vh - 370px); */
	/* display: flex;
	flex-direction: column;
	.context {
		flex: 1;
	} */
}
</style>
